export default __webpack_public_path__ + "static/media/truck.2eb9f84f.svg";